import React from 'react';
import { Link } from 'react-router-dom';
import './MarketsHero.css';

// We can reuse one of the graphics you already have
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const MarketsHero = () => {
  return (
    <section className="markets-hero-section">
      <div className="markets-hero-content">
        <h1>Understand the markets that move the world</h1>
        <p>
          Access prices, data, news, reports, and industry events across agricultural and energy segments; everything you need to stay informed and ahead.
        </p>
        <Link to="/signup">
          <button className="book-demo-btn">Book a demo</button>
        </Link>
      </div>
      <div className="markets-hero-graphic">
        <img src={graphicImg} alt="Market Insights Graphic" />
      </div>
    </section>
  );
};

export default MarketsHero;